import { viewportService } from '@/scripts/services/viewport';

export const isMobileView = (): boolean => viewportService.breakpoints.md === false;
